"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import Account from "../../api/account";
export class Path {
  constructor(basePath) {
    __publicField(this, "basePath");
    __publicField(this, "queries");
    this.basePath = basePath || [];
    this.queries = [];
  }
  appendToBase(strings) {
    this.basePath = this.basePath.concat(strings);
    return this;
  }
  addQueries(newQueries) {
    this.queries = this.queries.concat(newQueries);
    return this;
  }
  toString() {
    return this.pathString() + this.queryString();
  }
  pathString() {
    return [""].concat(this.basePath).join("/");
  }
  queryString() {
    const qs = this.queries.map((x) => x[0] + "=" + x[1]).join("&");
    return qs ? "?" + qs : "";
  }
  queryObj() {
    const query = {};
    this.queries.forEach((value) => {
      query[value[0]] = value[1];
    });
    return query;
  }
}
export function carrierInvoiceWithLoadPath(loadStateId, carrierInvoiceId, invoiceRequiresLtlReconciliation) {
  const rootPath = loadPath(loadStateId).appendToBase([
    "carrier_invoices",
    carrierInvoiceId.toString()
  ]);
  if (invoiceRequiresLtlReconciliation) {
    return rootPath.appendToBase(["ltl-reconcile"]);
  } else {
    return rootPath;
  }
}
function carrierInvoiceFromReplyPath(loadStateId, carrierInvoiceId, replyId, invoiceRequiresLtlReconciliation) {
  return carrierInvoiceWithLoadPath(
    loadStateId,
    carrierInvoiceId,
    invoiceRequiresLtlReconciliation
  ).addQueries([
    ["activeDocumentTab", "Messages"],
    ["emailId", replyId.toString()]
  ]);
}
function loadPath(loadStateId) {
  return new Path(["loads", loadStateId.toString()]);
}
function replyMessagePath(emailMessageId) {
  return new Path(["reply", emailMessageId.toString()]);
}
function emailMessagePath(emailMessageId) {
  return new Path(["email", emailMessageId.toString()]);
}
function forwardingEmailMessagePath(emailMessageId) {
  return new Path(["forwarding", "email_messages", emailMessageId.toString()]);
}
export function documentBatchWithEmailPath(documentBatchId, emailMessageId) {
  return documentBatchPath(documentBatchId).addQueries([
    ["emailId", emailMessageId.toString()]
  ]);
}
export function documentGroupPath(documentBatchId, documentGroupId) {
  return documentBatchPath(documentBatchId).addQueries([
    ["group_id", documentGroupId.toString()]
  ]);
}
export function documentBatchPath(documentBatchId) {
  return new Path(["index-document-batches", documentBatchId.toString()]);
}
function factorInvoice(factorInvoiceId) {
  return new Path(["factor_invoices", factorInvoiceId.toString()]);
}
function factorInvoiceWorkflow(factorInvoiceId) {
  return new Path(["factor_invoices_workflow", factorInvoiceId.toString()]);
}
export function factorInvoiceWorkflowWithEmail(factorInvoiceId, emailId, onDone) {
  const target = factorInvoiceWorkflow(factorInvoiceId);
  if (emailId) {
    target.addQueries([["emailId", emailId.toString()]]);
  }
  if (onDone) {
    target.addQueries([["onDone", encodeURIComponent(onDone)]]);
  }
  return target;
}
export function factorInvoiceWorkflowBatch(documentBatchId, emailId, factorInvoiceId, onDone) {
  const target = new Path([
    "factor_invoices_workflow",
    "batch",
    documentBatchId.toString()
  ]).addQueries([
    ["emailId", emailId.toString()],
    ["invoiceId", factorInvoiceId.toString()]
  ]);
  if (onDone) {
    target.addQueries([["onDone", encodeURIComponent(onDone)]]);
  }
  return target;
}
function factorInvoiceFromReply(factorInvoiceId, replyId) {
  return factorInvoice(factorInvoiceId).addQueries([
    ["activeDocumentTab", "Messages"],
    ["emailId", replyId.toString()]
  ]);
}
export function pathToEmail(emailParams) {
  return Account.matchAccountType({
    broker: () => {
      return invoiceIndexPath(emailParams);
    },
    factor: () => {
      return invoiceIndexPath(emailParams);
    },
    forwarder: () => {
      return forwardingEmailMessagePath(emailParams.emailMessageId);
    }
  });
}
function invoiceIndexPath(emailParams) {
  if (emailParams.maybeConformingSubmission) {
    return carrierInvoiceWithLoadPath(
      emailParams.maybeConformingSubmission.loadStateId,
      emailParams.maybeConformingSubmission.carrierInvoice.invoiceId,
      emailParams.maybeConformingSubmission.carrierInvoice.requiresLtlReconciliation
    );
  }
  if (emailParams.maybeInvoiceOwnerParams && emailParams.maybeDocumentBatchId) {
    return invoiceOwnerPath(emailParams, emailParams.maybeInvoiceOwnerParams);
  } else {
    return pathToMaybeDocumentBatch(emailParams);
  }
}
function invoiceOwnerPath(emailParams, invoiceOwnerParams) {
  switch (invoiceOwnerParams.kind) {
    case "carrier":
      return carrierInvoiceFromReplyPath(
        invoiceOwnerParams.loadStateId,
        invoiceOwnerParams.carrierInvoice.invoiceId,
        emailParams.emailMessageId,
        invoiceOwnerParams.carrierInvoice.requiresLtlReconciliation
      );
    case "factor":
      return factorInvoiceFromReply(
        invoiceOwnerParams.factorInvoiceId,
        emailParams.emailMessageId
      );
  }
}
function pathToMaybeDocumentBatch(emailParams) {
  if (emailParams.maybeDocumentBatchId) {
    const queries = isReply(emailParams.maybeEmailType) ? [["fromReply", "true"]] : [];
    return documentBatchWithEmailPath(
      emailParams.maybeDocumentBatchId,
      emailParams.emailMessageId
    ).addQueries(queries);
  } else {
    if (isReply(emailParams.maybeEmailType)) {
      return replyMessagePath(emailParams.emailMessageId);
    } else {
      return emailMessagePath(emailParams.emailMessageId);
    }
  }
}
function isReply(emailType) {
  return !!(emailType && emailType.toLowerCase() === "reply");
}
export function buildFlowModeOnDoneUrl(basePath, searchString) {
  const params = new URLSearchParams(searchString);
  if (!params.has("started")) {
    params.set("started", "1");
  }
  const queryString = params.toString();
  return queryString ? `${basePath}?${queryString}` : basePath;
}
